<div class="p-7">

  <!-- HEADER -->
  <div class="flex items-start justify-between mb-6 flex-wrap gap-4">
    <div class="flex items-center gap-3">
      <button [routerLink]="['/marketing-forms']"
        class="flex-shrink-0 inline-flex items-center justify-center w-8 h-8 rounded-lg text-gray-500 hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-800 transition-colors">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
        </svg>
      </button>
      <div>
        <h1 class="text-[1.75rem] font-bold text-gray-900 dark:text-white leading-tight">Plantillas de formularios</h1>
        <p class="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
          Elige una plantilla para empezar más rápido
        </p>
      </div>
    </div>
    <div class="flex items-center gap-2">
      <button (click)="isCreateModalOpen = true"
        class="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-lg text-sm font-medium bg-brand-500 hover:bg-brand-600 text-white transition-colors">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
        </svg>
        Crear plantilla
      </button>
      <button [routerLink]="['/marketing-forms']"
        class="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-lg text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
        </svg>
        Mis formularios
      </button>
    </div>
  </div>

  <!-- FILTER PILLS -->
  <div class="flex items-center gap-2 flex-wrap mb-6">
    @for (f of typeFilters; track f.value) {
      <button (click)="setFilter(f.value)"
        class="px-4 py-2 rounded-full text-sm font-medium transition-colors"
        [class.bg-brand-500]="activeFilter === f.value"
        [class.dark:bg-white]="activeFilter === f.value"
        [class.text-white]="activeFilter === f.value"
        [class.dark:text-gray-900]="activeFilter === f.value"
        [class.bg-white]="activeFilter !== f.value"
        [class.dark:bg-gray-800]="activeFilter !== f.value"
        [class.text-gray-600]="activeFilter !== f.value"
        [class.dark:text-gray-400]="activeFilter !== f.value"
        [class.border]="activeFilter !== f.value"
        [class.border-gray-200]="activeFilter !== f.value"
        [class.dark:border-gray-700]="activeFilter !== f.value"
        [class.hover:bg-gray-50]="activeFilter !== f.value"
        [class.dark:hover:bg-gray-700]="activeFilter !== f.value"
      >{{ f.label }}</button>
    }
  </div>

  <!-- EMPTY STATE -->
  @if (!loading && templates.length === 0) {
    <div class="flex flex-col items-center justify-center py-24 text-center">
      <div class="w-16 h-16 mb-4 rounded-2xl bg-gray-100 dark:bg-gray-800 flex items-center justify-center">
        <svg class="w-8 h-8 text-gray-400 dark:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"/>
        </svg>
      </div>
      <p class="text-base font-semibold text-gray-900 dark:text-white">No hay plantillas disponibles</p>
      <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
        {{ activeFilter === 'all' ? 'Aún no se han creado plantillas.' : 'No hay plantillas para este tipo de formulario.' }}
      </p>
      @if (activeFilter !== 'all') {
        <button (click)="setFilter('all')"
          class="mt-4 text-sm font-medium text-brand-600 dark:text-brand-400 hover:underline">
          Ver todas las plantillas
        </button>
      }
    </div>
  }

  <!-- TABLE (inc24) -->
  @else {
    <div class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
      <div class="max-w-full overflow-x-auto custom-scrollbar">
        <table class="min-w-full">
          <thead class="border-b border-gray-100 dark:border-white/[0.05]">
            <tr>
              <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Nombre</th>
              <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Tipo</th>
              <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Estado</th>
              <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Creada</th>
              <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Última modificación</th>
              <th class="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-white/[0.05]">
            @if (loading) {
              @for (i of [1,2,3,4,5]; track i) {
                <tr>
                  <td class="px-5 py-3"><div class="h-4 w-40 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div></td>
                  <td class="px-5 py-3"><div class="h-5 w-20 bg-gray-200 dark:bg-gray-700 rounded-full animate-pulse"></div></td>
                  <td class="px-5 py-3"><div class="h-5 w-20 bg-gray-200 dark:bg-gray-700 rounded-full animate-pulse"></div></td>
                  <td class="px-5 py-3"><div class="h-4 w-24 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div></td>
                  <td class="px-5 py-3"><div class="h-4 w-24 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div></td>
                  <td class="px-5 py-3"></td>
                </tr>
              }
            } @else {
              @for (template of templates; track template.id) {
                <tr (click)="openDetail(template)" class="cursor-pointer hover:bg-gray-50/60 dark:hover:bg-white/[0.02]">
                  <td class="px-5 py-3 text-start">
                    <span class="block font-medium text-gray-800 dark:text-white/90">{{ template.name }}</span>
                    @if (template.description) {
                      <span class="block text-xs text-gray-400 dark:text-gray-500 truncate max-w-[280px]">{{ template.description }}</span>
                    }
                  </td>
                  <td class="px-5 py-3 text-start">
                    <span class="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium" [ngClass]="badgeClass(template.formType)">
                      {{ template.formType | formTypeLabel }}
                    </span>
                  </td>
                  <td class="px-5 py-3 text-start">
                    <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium" [ngClass]="statusBadgeClass(template.status)">
                      {{ statusLabel(template.status) }}
                    </span>
                  </td>
                  <td class="px-5 py-3 text-start text-theme-sm text-gray-500 dark:text-gray-400">
                    {{ template.datetimeCreated ? datetime.formatDate(template.datetimeCreated) : '—' }}
                  </td>
                  <td class="px-5 py-3 text-start text-theme-sm text-gray-500 dark:text-gray-400">
                    {{ template.datetimeUpdated ? datetime.formatDate(template.datetimeUpdated) : '—' }}
                  </td>
                  <td class="px-5 py-3 text-center" (click)="$event.stopPropagation()">
                    <div class="flex items-center justify-center gap-2">
                      <button (click)="openNameDialog(template)" title="Usar plantilla"
                        class="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-medium rounded-lg bg-brand-500 text-white hover:bg-brand-600 transition-colors">
                        Usar
                      </button>
                      <button (click)="editTemplate(template.id)" title="Editar"
                        class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/></svg>
                      </button>
                      <button (click)="archiveTemplate(template)" title="Archivar"
                        class="rounded-lg p-2 hover:bg-amber-50 hover:text-amber-600 dark:hover:bg-amber-500/10 transition-colors">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"/></svg>
                      </button>
                      <button (click)="deleteTemplate(template)" title="Eliminar"
                        class="rounded-lg p-2 hover:bg-error-50 hover:text-error-600 dark:hover:bg-error-500/10 transition-colors">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>
                      </button>
                    </div>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    </div>
  }

</div>

<!-- Modal de detalle de plantilla (inc24) -->
<app-modal [isOpen]="!!detailTemplate" (close)="closeDetail()" className="max-w-lg mx-4">
  @if (detailTemplate) {
    <div class="p-6 space-y-5">
      <div class="flex items-start gap-4">
        <div class="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-gradient-to-br text-white"
          [ngClass]="gradientClass(detailTemplate.formType)">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" [innerHTML]="typeIcon(detailTemplate.formType)"></svg>
        </div>
        <div class="min-w-0">
          <h2 class="text-lg font-bold text-gray-900 dark:text-white break-words">{{ detailTemplate.name }}</h2>
          <div class="flex items-center gap-2 mt-1">
            <span class="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium" [ngClass]="badgeClass(detailTemplate.formType)">
              {{ detailTemplate.formType | formTypeLabel }}
            </span>
            <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium" [ngClass]="statusBadgeClass(detailTemplate.status)">
              {{ statusLabel(detailTemplate.status) }}
            </span>
          </div>
        </div>
      </div>

      @if (detailTemplate.description) {
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Descripción</p>
          <p class="text-sm text-gray-700 dark:text-gray-300 whitespace-pre-wrap break-words">{{ detailTemplate.description }}</p>
        </div>
      }

      <div class="grid grid-cols-2 gap-4 pt-2 border-t border-gray-200 dark:border-gray-700">
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">Creada</p>
          <p class="text-sm text-gray-800 dark:text-gray-200">{{ detailTemplate.datetimeCreated ? datetime.formatDateTime(detailTemplate.datetimeCreated) : '—' }}</p>
        </div>
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">Última modificación</p>
          <p class="text-sm text-gray-800 dark:text-gray-200">{{ detailTemplate.datetimeUpdated ? datetime.formatDateTime(detailTemplate.datetimeUpdated) : '—' }}</p>
        </div>
      </div>

      <div class="flex justify-end gap-2 pt-2">
        <button (click)="editTemplate(detailTemplate.id)"
          class="px-4 py-2 text-sm font-medium rounded-lg border border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
          Editar
        </button>
        <button (click)="openNameDialog(detailTemplate); closeDetail()"
          class="px-4 py-2 text-sm font-medium rounded-lg bg-brand-500 text-white hover:bg-brand-600 transition-colors">
          Usar plantilla
        </button>
      </div>
    </div>
  }
</app-modal>

<!-- Create template modal -->
<app-form-modal
  [isOpen]="isCreateModalOpen"
  [loading]="isCreating"
  [isTemplate]="true"
  (closeModal)="isCreateModalOpen = false"
  (create)="onCreateTemplate($event)"
/>

<!-- Name dialog -->
<app-modal
  [isOpen]="nameDialogOpen"
  (close)="closeNameDialog()"
  className="max-w-md mx-auto"
>
  <div class="p-6">
    <h2 class="text-base font-semibold text-gray-900 dark:text-white mb-1">Nombra tu formulario</h2>
    <p class="text-sm text-gray-500 dark:text-gray-400 mb-5">
      Basado en: <span class="font-medium text-gray-700 dark:text-gray-300">{{ selectedTemplate?.name }}</span>
    </p>

    <div class="mb-5">
      <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1.5">Nombre del formulario</label>
      <input
        type="text"
        [(ngModel)]="newFormName"
        (keydown.enter)="useTemplate()"
        placeholder="Ej. Registro newsletter Q1"
        class="w-full px-3 py-2.5 text-sm rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition"
        autofocus
      />
    </div>

    <div class="flex justify-end gap-2">
      <button (click)="closeNameDialog()"
        class="px-4 py-2 text-sm font-medium rounded-lg text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors">
        Cancelar
      </button>
      <button (click)="useTemplate()" [disabled]="!newFormName.trim() || cloning"
        class="inline-flex items-center gap-1.5 px-5 py-2 text-sm font-medium rounded-lg bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-60 disabled:cursor-not-allowed transition-colors">
        @if (cloning) {
          <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
          </svg>
          Creando...
        } @else {
          Crear formulario
        }
      </button>
    </div>
  </div>
</app-modal>
